<template>
    <div class="container" ref="notification">
       <div id="notification_bar" class='col-lg-8 pl-0 mb-4'>
        <div v-if="notification" id="notification" class="notification_button p-3">
          <div class="row h-100">
            <div class="col-9 my-auto">
              <div class="m-0 text-white" v-html="notification.notification"></div>
            </div>
            <div class="col-3 my-auto text-right">
              <button class="no_btn text-white" v-on:click="setCookie()">X</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      notification: null
    }
  },

  methods: {
    checkForCookies (notifications) {
      // Loop through the cookie keys and pull out the corresponding notification ids into their own array
      let keys = this.$cookies.keys()
      let ids = []
      for (var i = 0; i < keys.length; i++) {
        var matchingCookie = keys[i].split('|')
        ids.push(matchingCookie[1])
      }

      // Loop through the ids, and and the notification ids. If there is a match, unset the notification from the notifications array
      for (var x = 0; x < ids.length; x++) {
        for (var a = 0; a < notifications.length; a++) {
          if (notifications[a].id == ids[x]) {
            notifications.splice(a, 1)
            break
          }
        }
      }

      // If there are notification(s) remaining, set this.notification to the first notification in the notifications array
      if (notifications[0]) {
        this.notification = notifications[0]
      }
    },
    setCookie () {
      this.$refs.notification.style.display = 'none'
      let expiryDate = this.notification.end_date.split('-')
      for (var i = 0; i < expiryDate.length; i++) {
        expiryDate[i] = parseInt(expiryDate[i])
      }
      let cookie = {
        id: this.notification.id,
        notification: this.notification.notification,
        expiry: (new Date(expiryDate[0], expiryDate[1], expiryDate[2]))
      }
      this.$cookies.set(
        ('ontario_newsroom_session|' + this.notification.id),
        cookie,
        new Date(expiryDate[0], expiryDate[1], expiryDate[2])
      )
    },
    getNotification () {
      let notifications = []
      this.$axios
        .get(process.env.VUE_APP_ROOT_API + 'notifications', {
          params: {
            language: this.$root.$i18n.locale
          }
        })
        .then(response => {
          notifications = response.data.data
        })
        .catch(error => {
          console.log(error.response.status, error.response.data.message)
        })
        .finally(() => this.checkForCookies(notifications))
    }
  },

  mounted () {
    this.getNotification()
  }

}
</script>
